const formatDate = (dateString) => {
    if (!dateString) return "-";

    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }).format(new Date(dateString));
};


export default function () {
    return {
        formatDate
    }
};
